import { Command } from '@/app/tracking/api';
import { QuizSessionPhase } from './quiz-session-phase';

interface QuizSession {
  id: string
  quizId: string
  aspect: string
  type: string // e.g. exam or practice
  phase: QuizSessionPhase
  state: unknown
}

export type UpdateQuizSessionTrackingCommandPayload = QuizSession

export const UpdateQuizSessionTrackingCommandName = 'update-quiz-session' as const;
export type UpdateQuizSessionTrackingCommand =
      Command<typeof UpdateQuizSessionTrackingCommandName, UpdateQuizSessionTrackingCommandPayload>;
